import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons';
import Tooltip from '@components/ui/Tooltip/next';

import { IconTab, StyledTabs, Tab, TabsDiv, Wrapper } from './style';

interface TabProps {
  id: string;
  label: string;
  disabled: boolean;
  name: string;
}

interface SortingTabsProps {
  data: TabProps[];
  activeKey: string;
  select?: string;
  handleTabClick: (
    key: string,
    e: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>
  ) => void;
}
const TourText =
  'Turlar kullanıcı seçimine göre; popüler, artan fiyat, azalan fiyata göre sıralanır. Sıralama; artan veya azalan fiyat seçimi yapıldığında fiyatlara göre, popüler seçimi yapıldığında ise Setur’un değişken tercihlerine göre yapılır.';
const HotelText =
  'Tesisler kullanıcı seçimine göre; popüler, artan fiyat, azalan fiyat, artan indirim, azalan indirime göre sıralanır. Sıralama; artan veya azalan fiyat seçimi yapıldığında fiyatlara göre, artan veya azalan indirim seçimi yapıldığında indirime göre, popüler seçimi yapıldığında ise Setur’un değişken tercihlerine göre yapılır.';

const SortingTabs = ({
  data,
  activeKey,
  select,
  handleTabClick,
}: SortingTabsProps) => {
  return (
    <Wrapper>
      <TabsDiv>
        <Tooltip
          overlayInnerStyle={{
            maxWidth: '343px',
            lineHeight: 1.43,
            textAlign: 'left',
          }}
          trigger='click'
          placement='bottomLeft'
          title={<span>{select === 'hotel' ? HotelText : TourText}</span>}
        >
          <Tab>
            <IconTab>
              <CustomIcon
                icon={InfoIcon}
                paletteColor='darkGrey'
                data-testid='icon-container'
                fontSize={24}
              />
            </IconTab>
          </Tab>
        </Tooltip>
      </TabsDiv>
      <StyledTabs activeKey={activeKey} onTabClick={handleTabClick}>
        {data?.map((tab) => {
          return (
            <StyledTabs.TabPane
              disabled={tab.disabled}
              tab={tab.label}
              key={tab.id}
            />
          );
        })}
      </StyledTabs>
    </Wrapper>
  );
};

export default SortingTabs;
